export const emptyImage = (): Image => ({
  id: undefined,
  filename: ""
})

export default interface Image {
  id?: number
  filename: string
}